var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeDarkGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 7.5C10.663 7.5 11.2988 7.76339 11.7677 8.23223C12.2365 8.70107 12.4999 9.33696 12.4999 10C12.4999 10.663 12.2365 11.2989 11.7677 11.7678C11.2988 12.2366 10.663 12.5 9.99992 12.5C9.33688 12.5 8.70099 12.2366 8.23215 11.7678C7.76331 11.2989 7.49992 10.663 7.49992 10C7.49992 9.33696 7.76331 8.70107 8.23215 8.23223C8.70099 7.76339 9.33688 7.5 9.99992 7.5ZM9.99992 3.75C14.1666 3.75 17.7249 6.34167 19.1666 10C17.7249 13.6583 14.1666 16.25 9.99992 16.25C5.83325 16.25 2.27492 13.6583 0.833252 10C2.27492 6.34167 5.83325 3.75 9.99992 3.75ZM2.64992 10C3.32346 11.3753 4.36934 12.534 5.66865 13.3444C6.96796 14.1548 8.46858 14.5844 9.99992 14.5844C11.5313 14.5844 13.0319 14.1548 14.3312 13.3444C15.6305 12.534 16.6764 11.3753 17.3499 10C16.6764 8.62474 15.6305 7.46604 14.3312 6.65562C13.0319 5.8452 11.5313 5.41557 9.99992 5.41557C8.46858 5.41557 6.96796 5.8452 5.66865 6.65562C4.36934 7.46604 3.32346 8.62474 2.64992 10Z",
    fill: "#204A22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeDarkGreenIcon);
export default __webpack_public_path__ + "static/media/eye-dark-green-icon.003b9dca90e702ace2e9361d5c721d79.svg";
export { ForwardRef as ReactComponent };